import { atom } from 'recoil';

const latestChangelogState = atom<any[]>({
  key: 'latest-changelog',
  default: [],
});

export { latestChangelogState };
